import { Link, useLocation } from "react-router-dom";
import { Phone, Menu } from "lucide-react";
import { useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LOGO = "/brand/themboys-banner.jpg";

const navItems = [
  { label: "Services", href: "/#services" },
  { label: "Quote", href: "/#quote" },
  { label: "Work", href: "/#work" },
  { label: "Coverage", href: "/#coverage" },
  { label: "Track", href: "/track" },
  { label: "FAQ", href: "/#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F5F3EC]/85 border-b border-[#DDD8C9]"
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl flex items-center justify-between px-5 lg:px-8 h-16">
        <Link to="/" className="flex items-center group" data-testid="site-logo">
          <img
            src={LOGO}
            alt="Them Boys Moving & Storage · (502) 507-7904"
            className="h-12 lg:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-sm font-medium text-[#151816] hover:text-[#5BB239] transition-colors duration-200"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+15025077904"
            className="flex items-center gap-1.5 text-sm font-semibold text-[#223932] hover:text-[#5BB239] transition-colors"
            data-testid="header-phone"
          >
            <Phone className="w-3.5 h-3.5" />
            (502) 507-7904
          </a>
          <a
            href="/#book"
            className="inline-flex items-center bg-[#5BB239] text-white px-4 py-2 text-sm font-bold uppercase tracking-wider hover:bg-[#499828] transition-colors"
            data-testid="nav-book-btn"
          >
            Book Now
          </a>
          {pathname !== "/admin" && (
            <Link
              to="/admin"
              className="text-xs font-mono-label text-[#5C635F] hover:text-[#223932] transition-colors"
              data-testid="nav-admin-btn"
            >
              Admin
            </Link>
          )}
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="md:hidden p-2" data-testid="mobile-menu-btn">
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#F5F3EC]">
            <div className="flex flex-col gap-6 mt-10">
              {navItems.map((n) => (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-xl font-display font-bold"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="/#book"
                onClick={() => setOpen(false)}
                className="bg-[#5BB239] text-white px-6 py-3 text-sm font-bold uppercase tracking-wider text-center"
              >
                Book Now
              </a>
              <Link to="/admin" className="text-sm text-[#5C635F]">
                Admin
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
